<template>
  <span class="titlePages">{{ title }}</span>
  <div class="mapa-wrapper">
    <div class="controles-custom-top-left">
      <v-menu
        v-if="allRajantArray.length > 0"
        :close-on-content-click="false"
        location="bottom start"
      >
       <template v-slot:activator="{ props }">
      <v-btn color="#84D98E" v-bind="props" prepend-icon="mdi-truck" elevation="2">
      </v-btn>
    </template>

    <v-card min-width="400" max-height="600" class="overflow-y-auto mt-2">
      <v-list v-model:opened="openedGroups" density="compact">
        
         <v-list-group value="seccion_clientes">
          <template v-slot:activator="{ props }">
            <v-list-item v-bind="props" prepend-icon="mdi-dump-truck" title="CLIENTES"></v-list-item>
          </template>
          <v-list-item class="py-2">
            <v-switch
              v-model="showAllClients"
              label="Mostrar Todo"
              color="green"
              hide-details
            ></v-switch>
          </v-list-item>

            <v-divider class="border-opacity-25 my-2"></v-divider>

            <v-list-group v-for="subtipo in jerarquiaEquipos" :key="'client-' + subtipo.nombre" :value="'client-' + subtipo.nombre">
              <template v-slot:activator="{ props }">
                <v-list-item v-bind="props">
                  <template v-slot:prepend>
                    <v-icon icon="mdi-transit-connection-variant" color="white" class="mr-2"></v-icon>
                  </template>
                  <v-list-item-title class="text-subtitle-1 font-weight-bold">
                    {{ subtipo.nombre }}
                  </v-list-item-title>
                  <template v-slot:append>
                    <v-checkbox-btn 
                      :model-value="isSubtipoSelectedCliente(subtipo)" 
                      @click.stop="toggleSubtipoCliente(subtipo)"
                      color="green"
                      hide-details
                    ></v-checkbox-btn>
                  </template>
                </v-list-item>
              </template>

              <v-list-group v-for="tipo in subtipo.tipos" :key="'client-tipo-' + subtipo.nombre + tipo.nombre" :value="'client-tipo-' + subtipo.nombre + tipo.nombre">
                <template v-slot:activator="{ props }">
                  <v-list-item v-bind="props" bg-color="#1e293b" class="pl-6">
                    <template v-slot:prepend>
                      <v-icon icon="mdi-folder-outline" size="small" class="mr-n2"></v-icon>
                    </template>
                    <v-list-item-title class="text-body-2">{{ tipo.nombre }}</v-list-item-title>
                    <template v-slot:append>
                      <v-checkbox-btn 
                        :model-value="isTipoSelectedCliente(tipo)" 
                        @click.stop="toggleTipoCliente(tipo)"
                        color="green"
                        hide-details
                      ></v-checkbox-btn>
                    </template>
                  </v-list-item>
                </template>

                <v-list-group v-for="eq in tipo.equipos" :key="eq.ip" :value="eq.ip">
                  <template v-slot:activator="{ props }">
                    <v-list-item v-bind="props" class="pl-10">
                      <template v-slot:prepend>
                        <v-checkbox-btn 
                          :model-value="selectedEquiposCliente.includes(eq.ip)" 
                          @click.stop="toggleEquipo(eq)"
                          color="green"
                          hide-details
                        ></v-checkbox-btn>
                      </template>
                      <v-list-item-title class="text-caption font-weight-bold">{{ eq.tag }}</v-list-item-title>
                    </v-list-item>
                  </template>

                  <v-list-item v-for="mac in eq.macs" :key="mac" class="pl-16" density="compact">
                    <template v-slot:prepend>
                      <v-checkbox-btn 
                        v-model="selectedMacs" 
                        :value="`${eq.ip}-${mac}`"
                        color="green"
                        density="compact"
                        hide-details
                      ></v-checkbox-btn>
                    </template>
                    <v-list-item-title class="text-caption text-grey">MAC: {{ mac }}</v-list-item-title>
                  </v-list-item>
                </v-list-group>

              </v-list-group>
            </v-list-group>

        </v-list-group>

        <v-divider></v-divider>

       <v-list-group value="temperatura_root">
          <template v-slot:activator="{ props }">
            <v-list-item v-bind="props" prepend-icon="mdi-robot-excited-outline" title="IA"></v-list-item>
          </template>

          
        <v-list-item class="py-2">
          <v-switch
            v-model="showAllClustering"
            label="Clustering"
            color="green"
            hide-details
          ></v-switch>
        </v-list-item>

        <v-divider></v-divider>

          <v-list-item>
            <v-switch
              v-model="allVisibleTemperatura"
              label="Mostrar todo"
              hide-details
              color="green"
              @change="toggleAll()"
            ></v-switch>
          </v-list-item>

          <v-list-group v-for="(subtipoData, subtipo) in hierarchy" :key="'temp-' + subtipo" :value="'temp-' + subtipo">
            <template v-slot:activator="{ props }">
              <v-list-item v-bind="props" class="py-2">
                <template v-slot:prepend>
                  <v-icon icon="mdi-transit-connection-variant" color="white" class="mr-2"></v-icon>
                </template>
                <v-list-item-title class="text-subtitle-1 font-weight-medium">
                  {{ subtipo }}
                </v-list-item-title>
                <template v-slot:append>
                  <v-checkbox-btn
                    :model-value="isSubtipoSelected(subtipo as any)"
                    @click.stop="toggleSubtipo(subtipo as any)"
                    color="green"
                    density="compact"
                    hide-details
                  ></v-checkbox-btn>
                </template>
              </v-list-item>
            </template>

            <v-list-group v-for="(equipos, tipo) in subtipoData" :key="tipo" :value="tipo">
              <template v-slot:activator="{ props }">
                <v-list-item v-bind="props" bg-color="#1e293b" class="pl-8">
                  <template v-slot:prepend>
                    <v-icon icon="mdi-folder-outline" size="small" class="mr-n2"></v-icon>
                  </template>
                  <v-list-item-title class="text-body-2">{{ tipo }}</v-list-item-title>
                  <template v-slot:append>
                    <v-checkbox-btn
                      :model-value="isTipoSelected(subtipo as any, tipo as any)"
                      @click.stop="toggleTipo(subtipo as any, tipo as any)"
                      color="green"
                      density="compact"
                      hide-details
                    ></v-checkbox-btn>
                  </template>
                </v-list-item>
              </template>

              <v-list-item v-for="equipo in equipos" :key="equipo.name" class="pl-16">
                <template v-slot:prepend>
                  <v-checkbox-btn
                    v-model="selectedEquiposTemperatura"
                    :value="equipo.name"
                    color="green"
                    density="compact"
                    hide-details
                    class="mr-2"
                  ></v-checkbox-btn>
                </template>
                <v-list-item-title class="text-caption font-weight-bold">
                  {{ equipo.name }}
                </v-list-item-title>
              </v-list-item>
            </v-list-group>

          </v-list-group>
        </v-list-group>

        <v-divider></v-divider>

        

      </v-list>
    </v-card>
      </v-menu>
    </div>

    <div id="mapClients" class="mapClients"></div>
  </div>
  <v-row v-if="showAllClustering" class="ma-0 mt-4" :justify="smAndDown ? 'center' : 'space-between'">
    <v-sheet color="transparent" :width="smAndDown ? '100%' : 360">
      <v-row class="ma-0" :justify="smAndDown ? 'center' : 'start'">
        <v-icon> mdi-thermometer-lines </v-icon>
        <span class="ml-2 mt-0 legendMapDash">
          {{ t("labels.temperature") }} |
          <span> {{ t("labels.averageTemperature") }}</span>
        </span>
      </v-row>
    </v-sheet>
    <rangeComponent
      :class="smAndDown ? 'mt-2' : 'mt-0'"
      :principal-color="COLOR.green"
      :secundary-color="'rgb(62 97 57)'"
      :color-text-princ="'white'"
      :color-text-secun="'white'"
      :principal-text="t('labels.ok')"
      :secundary-text="'-40°C a 30°C'"
      :sheetWidth="smAndDown ? 350 : 225"
    />
    <rangeComponent
      :class="smAndDown ? 'mt-2' : 'mt-0'"
      :principal-color="COLOR.yellow"
      :secundary-color="'#B4A343'"
      :color-text-princ="'black'"
      :color-text-secun="'white'"
      :principal-text="t('labels.normal')"
      :secundary-text="'31°C a 60°C'"
      :sheetWidth="smAndDown ? 350 : 225"
    />
    <rangeComponent
      :class="smAndDown ? 'mt-2' : 'mt-0'"
      :principal-color="COLOR.orange"
      :secundary-color="'#a87119'"
      :color-text-princ="'white'"
      :color-text-secun="'white'"
      :principal-text="t('labels.verifying')"
      :secundary-text="'61°C a 70°C'"
      :sheetWidth="smAndDown ? 350 : 225"
    />
    <rangeComponent
      :class="smAndDown ? 'mt-2' : 'mt-0'"
      :principal-color="COLOR.red"
      :secundary-color="'#8F3A36'"
      :color-text-princ="'white'"
      :color-text-secun="'white'"
      :principal-text="t('labels.alert')"
      :secundary-text="'Mayor a 70°C'"
      :sheetWidth="smAndDown ? 350 : 225"
    />
  </v-row>

<v-sheet
  v-if="hoverData.show"
  :style="{ 
    position: 'absolute', 
    left: (hoverData.x + 85) + 'px', 
    top: (hoverData.y + 15) + 'px', 
    zIndex: 100,
    pointerEvents: 'none' /* Importante: para que el sheet no interfiera con el mousemove */
  }"
  class="pa-3 rounded-lg elevation-10" 
  color="grey-darken-4" 
  theme="dark"
  width="230"
>
  <div class="text-green-accent-3 font-weight-bold">{{ hoverData.nombre }}</div>
  <div class="text-caption text-grey-lighten-1">{{ hoverData.ip }}</div>
  
  <v-divider class="my-2" color="white"></v-divider>
  
  <div class="d-flex justify-space-between text-body-2">
    <span class="text-grey">Temperatura:</span>
    <span>{{ hoverData.temp }}°C</span>
  </div>
  <div class="d-flex justify-space-between text-body-2">
    <span class="text-grey">Voltaje Sensor In:</span>
    <span>{{ hoverData.volt }}V</span>
  </div>
  <div class="d-flex justify-space-between text-body-2">
    <span class="text-grey">Noise:</span>
    <span>{{ hoverData.noise }}</span>
  </div>
</v-sheet>
</template>

<script setup lang="ts">
import { watch, ref, onMounted, computed } from "vue";

/********************************
 ************ STORE *************
 *******************************/
import { useStore } from "vuex";
const store = useStore();

/********************************
 ************ I18N **************
 *******************************/
import { useI18n } from "vue-i18n";
const { t } = useI18n();

/********************************
 ************ VUETIFY ***********
 *******************************/
import { useDisplay } from "vuetify";
const { smAndDown } = useDisplay();

/********************************
 *********** MAPLIBRE ***********
 *******************************/
import maplibregl, { LngLatLike } from "maplibre-gl";
import "maplibre-gl/dist/maplibre-gl.css";

/********************************
 ********** CONSTANTES **********
 *******************************/
import CONSTMAPS from "@/constants/maps";
import { LABELS } from "@/constants/labels";

/********************************
 *********** SERVICES ***********
 *******************************/
import {
  getAllDriveClientsDevices,
  getRajantGPS,
} from "@/services/Smartlink/Drive";


/**
 * Título de la vista
 */
const title = ref("Mina Visual");

import { getAllHexagonTemperature, getDataTemperaturePredictLastMinute } from "../../../services/Smartlink/Map";
import { COLOR } from "@/constants/colors";

import rangeComponent from "@/components/SmartLink/dashboard/rangeComponent.vue";

interface EquipoJerarquia {
    ip: string;
    tag: string;
    macs: string[];
}

// --- ESTADO REACTIVO ---
const selectedEquiposCliente = ref<string[]>([]);
const selectedMacs = ref<string[]>([]);
const showAllClients = ref(true);
const openedGroups = ref([]);
const jerarquiaEquipos = ref<any[]>([]);

/**
 * 1. PROCESAMIENTO DE JERARQUÍA (4 NIVELES)
 */
const inicializarJerarquia = async (data: any[]) => {
    const tree = new Map();

    data.forEach(equipo => {
        const subtipo = equipo.rol || "Acceso";
        const tipo = equipo.tipo || "General";

        if (!tree.has(subtipo)) tree.set(subtipo, new Map());
        const subtipoMap = tree.get(subtipo);

        if (!subtipoMap.has(tipo)) subtipoMap.set(tipo, []);

        // Procesar MACs desde el campo wireless
        const wireless = typeof equipo.wireless === 'string' ? JSON.parse(equipo.wireless) : equipo.wireless;
        const listaMacs: string[] = [];
        if (wireless) {
            Object.values(wireless).forEach((wlan: any) => {
                wlan.clients?.forEach((c: any) => listaMacs.push(c.mac));
            });
        }

        subtipoMap.get(tipo).push({
            ip: equipo.ip,
            tag: equipo.name || equipo.ip,
            macs: listaMacs
        });
    });

    jerarquiaEquipos.value = Array.from(tree).map(([nombreSubtipo, tiposMap]) => ({
        nombre: nombreSubtipo,
        tipos: Array.from(tiposMap as Map<string, EquipoJerarquia[]>).map(([nombreTipo, equipos]) => ({
            nombre: nombreTipo,
            equipos: equipos
        }))
    }));
};

/**
 * 2. FUNCIONES DE CONTROL (CHECKBOXES)
 */

// Nivel 1: Subtipo
const toggleSubtipoCliente = (subtipo: any) => {
    const equipos = subtipo.tipos.flatMap((t: any) => t.equipos);
    const ips = equipos.map((e: any) => e.ip);
    const macsCompuestas = equipos.flatMap((e: any) => e.macs.map((m: string) => `${e.ip}-${m}`));

    const allSelected = ips.every((ip: string) => selectedEquiposCliente.value.includes(ip));

    if (allSelected) {
        selectedEquiposCliente.value = selectedEquiposCliente.value.filter(ip => !ips.includes(ip));
        selectedMacs.value = selectedMacs.value.filter(m => !macsCompuestas.includes(m));
    } else {
        selectedEquiposCliente.value = [...new Set([...selectedEquiposCliente.value, ...ips])];
        selectedMacs.value = [...new Set([...selectedMacs.value, ...macsCompuestas])];
    }
};

// Nivel 2: Tipo
const toggleTipoCliente = (tipo: any) => {
    const ips = tipo.equipos.map((e: any) => e.ip);
    const macsCompuestas = tipo.equipos.flatMap((e: any) => e.macs.map((m: string) => `${e.ip}-${m}`));

    const allSelected = ips.every((ip: string) => selectedEquiposCliente.value.includes(ip));

    if (allSelected) {
        selectedEquiposCliente.value = selectedEquiposCliente.value.filter((ip: string) => !ips.includes(ip));
        selectedMacs.value = selectedMacs.value.filter((m: string) => !macsCompuestas.includes(m));
    } else {
        selectedEquiposCliente.value = [...new Set([...selectedEquiposCliente.value, ...ips])];
        selectedMacs.value = [...new Set([...selectedMacs.value, ...macsCompuestas])];
    }
};

// Nivel 3: Equipo (IP)
const toggleEquipo = (equipo: any) => {
    const ip = equipo.ip;
    const macsCompuestas = equipo.macs.map((m: string) => `${ip}-${m}`);

    if (selectedEquiposCliente.value.includes(ip)) {
        selectedEquiposCliente.value = selectedEquiposCliente.value.filter(i => i !== ip);
        selectedMacs.value = selectedMacs.value.filter(m => !macsCompuestas.includes(m));
    } else {
        selectedEquiposCliente.value.push(ip);
        selectedMacs.value = [...new Set([...selectedMacs.value, ...macsCompuestas])];
    }
};

// Switch Maestro
const toggleAllClients = (value: boolean | null) => {
    if (value) {
        const ips = allRajantArray.value.map((e: any) => e.ip);
        const macs: string[] = [];
        allRajantArray.value.forEach((e: any) => {
            const wireless = typeof e.wireless === 'string' ? JSON.parse(e.wireless) : e.wireless;
            Object.values(wireless || {}).forEach((wlan: any) => {
                wlan.clients?.forEach((c: any) => macs.push(`${e.ip}-${c.mac}`));
            });
        });
        selectedEquiposCliente.value = ips;
        selectedMacs.value = macs;
    } else {
        selectedEquiposCliente.value = [];
        selectedMacs.value = [];
    }
};

watch(showAllClients, (val) => {
    if (val) {
        toggleAllClients(true);
    } else {
        toggleAllClients(false);
    }
});
/**
 * 3. CHECKERS DE ESTADO
 */
const isSubtipoSelectedCliente = (subtipo: any) => 
    subtipo.tipos.flatMap((t: any) => t.equipos).every((e: any) => selectedEquiposCliente.value.includes(e.ip));

const isTipoSelectedCliente = (tipo: any) => 
    tipo.equipos.every((e: any) => selectedEquiposCliente.value.includes(e.ip));

/**
 * 4. WATCHER PARA EL MAPA
 */
watch([selectedEquiposCliente, selectedMacs], () => {
    if (!mapClients || !mapClients.getLayer("layer-equipos-icono")) return;

    const filterEquipos = selectedEquiposCliente.value.length > 0
        ? ["in", ["get", "id"], ["literal", selectedEquiposCliente.value]]
        : ["==", ["get", "id"], "none"];

    const filterFinal = selectedMacs.value.length > 0
        ? ["in", ["get", "id"], ["literal", selectedMacs.value]]
        : ["==", ["get", "id"], "none"];

    mapClients.setFilter("layer-equipos-icono", filterEquipos);
    mapClients.setFilter("layer-clientes-macs", filterFinal);
    mapClients.setFilter("layer-enlaces", filterFinal);
}, { deep: true });

function processDataToGeoJSON(dataArray: any[]) {
  const points: any = { type: "FeatureCollection", features: [] };
  const lines: any = { type: "FeatureCollection", features: [] };

  dataArray.forEach((equipo) => {
    // Equipo principal
    points.features.push({
      type: "Feature",
      properties: {
        id: equipo.ip,
        type: "equipo",
        parentId: equipo.ip,
        name: equipo.name,
      },
      geometry: {
        type: "Point",
        coordinates: [equipo.longitud, equipo.latitud],
      },
    });

    const wireless =
      typeof equipo.wireless === "string"
        ? JSON.parse(equipo.wireless)
        : equipo.wireless;

    Object.values(wireless).forEach((wlan: any) => {
      if (wlan.clients) {
        wlan.clients.forEach((client: any) => {
          // Dispersión de clientes para que no queden uno encima de otro
          const cLng = equipo.longitud + (Math.random() - 0.5) * 0.005;
          const cLat = equipo.latitud + (Math.random() - 0.5) * 0.005;

          // --- CLAVE: ID ÚNICO COMPUESTO ---
          const uniqueId = `${equipo.ip}-${client.mac}`;

          if(client.signal !== undefined && client.signal !== 0){
            points.features.push({
              type: "Feature",
              properties: {
                id: uniqueId,
                type: "cliente",
                parentId: equipo.ip,
                mac: client.mac,
                signal: client.signal ?? 0,
              },
              geometry: { type: "Point", coordinates: [cLng, cLat] },
            });

            lines.features.push({
              type: "Feature",
              properties: { id: uniqueId, parentId: equipo.ip, mac: client.mac },
              geometry: {
                type: "LineString",
                coordinates: [
                  [equipo.longitud, equipo.latitud],
                  [cLng, cLat],
                ],
              },
            });
          // }
          }

          
        });
      }
    });
  });
  return { points, lines };
}

/**
 * Obtener las posiciones de los equipos Rajant
 */
async function getRajantPositions() {
  await getDriveClientsDevices();
  await getALLRajantGPS();

  await inicializarJerarquia(allRajantArray.value)


  // 1. Generar los GeoJSON con la función que definimos antes
  const data = processDataToGeoJSON(allRajantArray.value);

  // 2. Añadir Sources
  mapClients.addSource("src-puntos", { type: "geojson", data: data.points });
  mapClients.addSource("src-enlaces", { type: "geojson", data: data.lines });

  // 3. Añadir Capas

  // Capa de Líneas (Enlaces)
  mapClients.addLayer({
    id: "layer-enlaces",
    type: "line",
    source: "src-enlaces",
    paint: {
      "line-color": "#00FFFF",
      "line-width": 2,
      "line-dasharray": [2, 1], // Línea punteada para los enlaces
    },
  });

  // Capa de Equipos (Tu Icono)
  mapClients.addLayer({
    id: "layer-equipos-icono",
    type: "symbol",
    source: "src-puntos",
    filter: ["==", ["get", "type"], "equipo"],
    layout: {
      "icon-image": "iconoSolarTrailer",
      "text-allow-overlap": true,
      "icon-size": 0.9,
      "icon-allow-overlap": true,
      "text-field": ["get", "name"],
      "text-size": 12,
      "text-offset": [0, 2],
      "text-anchor": "top",
    },
    paint: {
      "text-color": "#FFFFFF",
      "text-halo-color": "#000000",
      "text-halo-width": 2.0,
    },
  });

  mapClients.addLayer({
    id: "layer-clientes-macs",
    type: "symbol",
    source: "src-puntos",
    filter: ["==", ["get", "type"], "cliente"], // Solo clientes
    layout: {
      // Obtenemos la propiedad 'mac' + ' (signal dBm)' que guardamos en processDataToGeoJSON
      "text-field": [
        "concat",
        ["get", "mac"],
        " (",
        ["get", "signal"],
        " dBm)",
      ],
      "text-size": 14,
      "text-offset": [0, 0], // Centrado dentro o sobre el círculo
      "text-allow-overlap": true, // No permitir que se pisen entre ellos
      "text-ignore-placement": true,
    },
    paint: {
      "text-color": "#66BB6A", // Texto blanco
      "text-halo-color": "#000000", // Halo negro para legibilidad sobre cualquier mapa
      "text-halo-width": 2.0,
    },
  });
}


/**
 * Lista de los Equipos Rajant con toda su información (Ancho de Banda y GPS)
 */
const allRajantArray = ref<any>([]);

/**
 * Obtener todas las coordenadas GPS de los equipos Rajant
 */
async function getALLRajantGPS() {
  const allData = await getRajantGPS();

  if (allData.status === 400) {
    store.commit("showSnackBar", {
      type: LABELS.error,
      msg: t("snackbar.errorApis"),
      valor: true,
    });
  }
  if (allData.status === 200) {
    allRajantArray.value.forEach((item: any) => {
      allData.data.find(({ ip, latitud, longitud }: any) => {
        if (ip === item.ip) {
          item.latitud = latitud;
          item.longitud = longitud;
        }
      });
    });
  }
}

/**
 * Obtener el Ancho de Banda de todos los equipos Rajant
 */
async function getDriveClientsDevices() {
  const allData = await getAllDriveClientsDevices();

  if (allData.status === 400) {
    store.commit("showSnackBar", {
      type: LABELS.error,
      msg: t("snackbar.errorApis"),
      valor: true,
    });
  }
  if (allData.status === 200) {
    allRajantArray.value = allData.data;
  }
  // allRajantArray.value = DRIVECLIENTS
}

const showAllClustering = ref(false);

/*****************************************************
 ** HEXÁGONOS DE TEMPERATURA (CLUSTERING DE CALOR) **
 ***************************************************/

async function renderHexagons(map:any) {
  
  const allData:any = await getAllHexagonTemperature()

  if( allData.status === 400 ){
      store.commit('showSnackBar', {type: LABELS.error, msg: t('snackbar.errorApis'), valor : true});
  }
  if( allData.status === 200 ){
    const geojsonData = allData.data

      // Si la fuente ya existe (por una actualización), actualizamos los datos
    if (map.getSource('hexagonos-clustering')) {
      map.getSource('hexagonos-clustering').setData(geojsonData);
    } else {
      map.addSource('hexagonos-clustering', {
        type: 'geojson',
        data: geojsonData
      });

      // 3. Añadir la Capa de Relleno (Fill)
      map.addLayer({
        id: 'layer-hexagonos-fill',
        type: 'fill',
        source: 'hexagonos-clustering',
        layout: { 
          'visibility': 'none' // <--- OCULTO POR DEFECTO
        },
        paint: {
          // Usamos la propiedad 'color' que ya viene en tu GeoJSON
          'fill-color': ['get', 'color'],
          'fill-opacity': 0.6
        }
      });

      // 4. Añadir una Capa de Línea (Bordes) para que se vea definido
      map.addLayer({
        id: 'layer-hexagonos-line',
        type: 'line',
        source: 'hexagonos-clustering',
        layout: { 
          'visibility': 'none' // <--- OCULTO POR DEFECTO
        },
        paint: {
          'line-color': '#ffffff',
          'line-width': 0.5,
          'line-opacity': 0.8
        }
      });

      // 5. Interactividad: Popup al hacer click
      map.on('click', 'layer-hexagonos-fill', (e: any) => {
        const props = e.features[0].properties;

        // Creamos el popup
        new maplibregl.Popup()
          .setLngLat(e.lngLat)
          .setHTML(`
            <div style="font-family: sans-serif; padding: 5px;">
              <strong style="display: block; font-size: 1.1em; margin-bottom: 5px;">
                Estado: <span style="color: ${props.color}">${props.estado}</span>
              </strong>
              <strong>Temp. Promedio:</strong> ${props.tempPromedio} °C<br>
              <strong>Muestras:</strong> ${props.muestras}
            </div>
          `)
          .addTo(map);
      });

      // Cambiar el cursor al pasar sobre un hexágono
      map.on('mouseenter', 'layer-hexagonos-fill', () => map.getCanvas().style.cursor = 'pointer');
      map.on('mouseleave', 'layer-hexagonos-fill', () => map.getCanvas().style.cursor = '');
    }
  
  }
}


watch(showAllClustering, (val) => {
  if (!mapClients) return; // Asegúrate de tener acceso a la instancia del mapa

  const visibility = val ? 'visible' : 'none';

  if (mapClients.getLayer('layer-hexagonos-fill')) {
    mapClients.setLayoutProperty('layer-hexagonos-fill', 'visibility', visibility);
  }
  if (mapClients.getLayer('layer-hexagonos-line')) {
    mapClients.setLayoutProperty('layer-hexagonos-line', 'visibility', visibility);
  }
});

const ICON_IMGS:any ={
  "perforadora": 'iconoPerforadora',
  "pala": 'iconoPala',
  "camion": 'iconoCamion',
  "camion lte": 'iconoCamion',
  "cargador frontal": 'iconoCargadorFrontal',
  "solar trailer": 'iconoSolarTrailer',
  "ap movil": 'iconoSolarTrailer',
  "pipa agua": 'iconoPipaAgua',
  "tractor": 'iconoCamion',
}


/**********************************************************************
 ** OBTENER DATOS DE PREDICCIÓN DE TEMPERATURA PARA EL ÚLTIMO MINUTO **
 **********************************************************************/
const rawDataTemperatura = ref<Equipo[]>([]);
const selectedEquiposTemperatura = ref<string[]>([]);
const allVisibleTemperatura = ref(false);

const hoverData = ref({
  show: false,
  x: 0,
  y: 0,
  nombre: '',
  ip: '',
  temp: 0,
  volt: 0,
  noise: 0
});

interface Equipo {
  fecha: string;
  latitud: number;
  longitud: number;
  marca: string;
  name: string;
  noise: number;
  subtipo: string;
  temperatura: number;
  tipo: string;
  voltaje: number;
}


const hierarchy = computed(() => {
  const tree: any = {};
  rawDataTemperatura.value.forEach(e => {
    if (!tree[e.subtipo]) tree[e.subtipo] = {};
    if (!tree[e.subtipo][e.tipo]) tree[e.subtipo][e.tipo] = [];
    tree[e.subtipo][e.tipo].push(e);
  });
  return tree;
});

// --- Filtros ---
const toggleAll = () => {
  selectedEquiposTemperatura.value = allVisibleTemperatura.value ? rawDataTemperatura.value.map(e => e.name) : [];
};

const toggleSubtipo = (subtipo: string) => {
  const equiposNames = Object.values(hierarchy.value[subtipo]).flat().map((e: any) => e.name);
  const allPresent = equiposNames.every(name => selectedEquiposTemperatura.value.includes(name));
  
  if (allPresent) {
    selectedEquiposTemperatura.value = selectedEquiposTemperatura.value.filter(n => !equiposNames.includes(n));
  } else {
    selectedEquiposTemperatura.value = [...new Set([...selectedEquiposTemperatura.value, ...equiposNames])];
  }
};

const isSubtipoSelected = (subtipo: string) => {
  const equiposNames = Object.values(hierarchy.value[subtipo]).flat().map((e: any) => e.name);
  return equiposNames.every(name => selectedEquiposTemperatura.value.includes(name));
};

const toggleTipo = (subtipo: string, tipo: string) => {
  const equiposNames = hierarchy.value[subtipo][tipo].map((e: any) => e.name);
  const allPresent = equiposNames.every((name:any) => selectedEquiposTemperatura.value.includes(name));
  
  if (allPresent) {
    selectedEquiposTemperatura.value = selectedEquiposTemperatura.value.filter(n => !equiposNames.includes(n));
  } else {
    selectedEquiposTemperatura.value = [...new Set([...selectedEquiposTemperatura.value, ...equiposNames])];
  }
};

const isTipoSelected = (subtipo: string, tipo: string) => {
  return hierarchy.value[subtipo][tipo].every((e: any) => selectedEquiposTemperatura.value.includes(e.name));
};

// --- Watcher para actualizar el mapa ---
watch(selectedEquiposTemperatura, (newVal) => {
  if (mapClients && mapClients.getLayer('equipos-layer')) {
    mapClients.setFilter('equipos-layer', ['in', ['get', 'name'], ['literal', newVal]]);
  }
}, { deep: true });

/**
 * Configura o actualiza la fuente de datos y la capa de equipos en el mapa.
 * @param map instancia de MapLibre
 * @param data array de equipos obtenidos de la API
 */
const setupMapLayers = (map: maplibregl.Map, data: Equipo[]) => {
  // 1. Transformar datos a GeoJSON
  const geojsonData: GeoJSON.FeatureCollection = {
    type: 'FeatureCollection',
    features: data.map(e => ({
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [e.longitud, e.latitud]
      },
      properties: { ...e, icono: ICON_IMGS[e.tipo.toLowerCase() ?? 'tractor'] } // Pasamos todas las props para el hover sheet
    }))
  };

  // 2. Manejo de la Fuente (Source)
  // Si ya existe, actualizamos los datos; si no, la creamos.
  if (map.getSource('equipos')) {
    (map.getSource('equipos') as maplibregl.GeoJSONSource).setData(geojsonData);
  } else {
    map.addSource('equipos', {
      type: 'geojson',
      data: geojsonData
    });
  }

  // 3. Manejo de la Capa (Layer)
  if (!map.getLayer('equipos-layer')) {
    map.addLayer({
      id: 'equipos-layer',
      type: 'symbol',
      source: 'equipos',
      filter: ['in', ['get', 'name'], ['literal', selectedEquiposTemperatura.value]],
      layout: {
        // Lógica de iconos según subtipo
        'icon-image': ['get', 'icono'],
        'icon-size': 1.0,
        'icon-allow-overlap': true,
        'text-allow-overlap': true,
        // Configuración del texto (Nombre)
        'text-field': ['get', 'name'],
        'text-font': ['Open Sans Bold', 'Arial Unicode MS Bold'],
        'text-size': 12,
        'text-offset': [0, 1.5],
        'text-anchor': 'top'
      },
      paint: {
        'text-color': '#ffffff',
        'text-halo-color': '#2E7D32', // Halo verde (Green darken-3)
        'text-halo-width': 2
      }
    });

    allVisibleTemperatura.value = false; // Desactivamos el switch global al cargar la capa por primera vez

    // 4. Lógica de Interacción (Hover)
    map.on('mousemove', 'equipos-layer', (e) => {
      // Cambiar cursor
      map.getCanvas().style.cursor = 'pointer';

      if (e.features && e.features.length > 0) {
        const props = e.features[0].properties;
        
        // Capturamos la posición del mouse en la pantalla
        // e.point.x y e.point.y son relativos al canvas del mapa
        hoverData.value = {
          show: true,
          x: e.point.x,
          y: e.point.y,
          nombre: props.name,
          ip: props.marca, // O el campo que corresponda a IP
          temp: props.temperatura,
          volt: props.voltaje,
          noise: props.noise
        };
      }
    });

    map.on('mouseleave', 'equipos-layer', () => {
      map.getCanvas().style.cursor = '';
      hoverData.value.show = false;
    });
  }
};

async function getDataTempePredictLastMinute(){
  const allData = await getDataTemperaturePredictLastMinute();

  if (allData.status === 400) {
    store.commit("showSnackBar", {
      type: LABELS.error,
      msg: t("snackbar.errorApis"),
      valor: true,
    });
  }
  if (allData.status === 200) {
   // 1. Guardamos en nuestra variable reactiva para el menú de filtros
    rawDataTemperatura.value = allData.data;
    
    // 2. Inicializamos los seleccionados (por defecto todos visibles)
    // selectedEquiposTemperatura.value = rawDataTemperatura.value.map(e => e.name);

    // 3. LLAMADA A LA LÓGICA DEL MAPA
    // Asegúrate de que 'mapClients' sea accesible (variable global o ref)
    if (mapClients) {
      setupMapLayers(mapClients, allData.data);
    }
  }

}


watch(showAllClients,(val) => {
  if(val){    
    showAllClustering.value = false; // Desactivamos el clustering si se activa el switch de clientes
    allVisibleTemperatura.value = false; // Desactivamos el switch de temperatura si se activa el switch de clientes
  } 
});

watch(showAllClustering,(val) => {
  if(val){    
    showAllClients.value = false; // Desactivamos el switch de clientes si se activa el switch de clustering
  } 
});

watch(allVisibleTemperatura,(val) => {
  if(val){    
    showAllClients.value = false; // Desactivamos el switch de clientes si se activa el switch de clustering
  } 
});



let mapClients: any = "";
const centerMap = ref<LngLatLike>([
  CONSTMAPS.longitud.value,
  CONSTMAPS.latitud.value,
]);

import iconoSolarTrailer from "@/assets/Icons/solartrailer3.jpg";
import iconoPala from "@/assets/Icons/pala.jpg";
import iconoPerforadora from "@/assets/Icons/perforadora.jpg";
import iconoCamion from "@/assets/Icons/camion.jpg";
import iconoCargadorFrontal from "@/assets/Icons/cargadorfrontal.jpg"
import iconoPipaAgua from "@/assets/Icons/pipadeagua.jpg"

onMounted(async () => {
  mapClients = new maplibregl.Map({
    container: "mapClients",
    center: centerMap.value,
    zoom: 14,
    pitch: 40,
    bearing: 30,
    antialias: true,
    style:
      "https://api.maptiler.com/maps/satellite/style.json?key=6JWVt6LFaY22nquimZpF",
  });

  mapClients.addControl(new maplibregl.NavigationControl(), "top-right");
  mapClients.addControl(new maplibregl.FullscreenControl(), "top-right");

  const imgSolarTrailer = new Image(45, 45);

  imgSolarTrailer.onload = () => {
    mapClients.addImage("iconoSolarTrailer", imgSolarTrailer);
  };

  imgSolarTrailer.src = iconoSolarTrailer;

  const imgPala = new Image(45, 45);

  imgPala.onload = () => {
    mapClients.addImage("iconoPala", imgPala);
  };

  imgPala.src = iconoPala;

  const imgPerforadora = new Image(45, 45);

  imgPerforadora.onload = () => {
    mapClients.addImage("iconoPerforadora", imgPerforadora);
  };

  imgPerforadora.src = iconoPerforadora;

  const imgCamion = new Image(45, 45);

  imgCamion.onload = () => {
    mapClients.addImage("iconoCamion", imgCamion);
  };

  imgCamion.src = iconoCamion;

  const imgCargadorFrontal = new Image(45, 45);

  imgCargadorFrontal.onload = () => {
    mapClients.addImage("iconoCargadorFrontal", imgCargadorFrontal);
  };

  imgCargadorFrontal.src = iconoCargadorFrontal;

  const imgPipaAgua = new Image(45, 45);

  imgPipaAgua.onload = () => {
    mapClients.addImage("iconoPipaAgua", imgPipaAgua);
  };

  imgPipaAgua.src = iconoPipaAgua;


  mapClients.on("load", async () => {
    await renderHexagons(mapClients);
    await getRajantPositions();
    await getDataTempePredictLastMinute()
  });
});
</script>
